import store from '@/stores'
import { hasAction } from '@/utils/authActions'

/**
 *
 * 기존 권한 체크 대응 ${sa_actions.contains("StuffForStoreSearch")}
 *
 * 판정은 `utils/authActions.hasAction` 한 곳이다 — 여기는 그 술어에 **이 앱의 세션**을 먹이는 자리다
 * (스토어를 읽으므로 순수가 아니고, 그래서 판정을 갖지 않는다).
 *
 * @param {*} type 권한 string
 * @returns boolean
 */
export function checkAuthActionAccess(type) {
  return hasAction(store.getters['auth/auth'], type)
}
